import { Accordion } from '@/components/customercenter-ui/ui/accordion';

const PreQualificationAccordion = () => {
  return <Accordion type="single" collapsible className="w-full"></Accordion>;
};

export default PreQualificationAccordion;
